export const Circle = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M11.9998 23.3625C5.7373 23.3625 0.674805 18.2625 0.674805 12C0.674805 5.73755 5.7373 0.675049 11.9998 0.675049C18.2623 0.675049 23.3623 5.73755 23.3623 12C23.3623 18.2625 18.2623 23.3625 11.9998 23.3625ZM11.9998 2.36255C6.67481 2.36255 2.3623 6.67505 2.3623 12C2.3623 17.325 6.7123 21.675 12.0373 21.675C17.3623 21.675 21.7123 17.325 21.7123 12C21.6748 6.67505 17.3248 2.36255 11.9998 2.36255Z" fill="#8899A8" />
        </svg>
    );
};
